// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SendRmaRequest";
import { RmaModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Parameters<typeof PopulateApiParameter>[0];

export type ImagesBase64 = {
    [key: string]: string;
};

export interface UploadedImageDto {
    fileSize?: number;
    imageData?: string;
    fileName?: string;
}

export const AddImagesToProperties = (props: HandlerType) => {
    const state = props.getState();
    const orderLines = state.pages.requestRma.orderLines;
    const imagesBase64: ImagesBase64 = {};

    orderLines.map(orderLine => {
        if (orderLine.properties.imageDetails) {
            const { fileName, imageData } = orderLine.properties.imageDetails as UploadedImageDto;
            const fileExtension = fileName ? `.${fileName.split(".").pop()}` : "";

            if (imageData) {
                imagesBase64[`Attachment_${orderLine.properties.lineNumber}${fileExtension}`] = imageData;
            }
        }

        return imagesBase64;
    });

    props.apiParameter = {
        rmaModel: {
            ...props.apiParameter.rmaModel,
            properties: imagesBase64,
        } as RmaModel,
    };
};

addToChainAfter(chain, PopulateApiParameter, AddImagesToProperties);
